
import { DataQueryParameter } from './data-query-parameter.model';

export class DataQueryFunction {

	// Properties
	Description: string;
	DisplayName: string;
	Id: number;
	Name: string;
	ReturnType: string;
	SQL: string;

	// Methods
	getSyntax(parameters: DataQueryParameter[]) {
		// POST: obtains the syntax for the function
		let syntax = '';
		const params = parameters.filter(parameter => parameter.FunctionId == this.Id);
		syntax += this.Name + '(';
		for (let i = 0; i < params.length; i++) {
			const param = params.find(parameter => parameter.Position == i + 1);
			if (param != null) {
				if (i > 0) {
					syntax += ', ';
				}
				if (this.Name.toLowerCase() == 'date' && param.Name.toLowerCase() == 'format') {
					syntax += '<em>' + '"' + param.Name + '"' + '</em>';
				}
				else {
					syntax += '<em>' + param.Name + '</em>';
				}

			}
		}
		syntax += ')';
		return syntax;
	}

	getDescription(parameters: DataQueryParameter[]) {
		// POST: obtains the description for the function
		let desc = this.Description;
		const params = parameters.filter(parameter => parameter.FunctionId == this.Id);
		for (let i = 0; i < params.length; i++) {
			const param = params.find(parameter => parameter.Position == i + 1);
			if (param != null) {
				const stringToMatch = '\\{' + (i + 1) + '\\}';
				const regExp = new RegExp(stringToMatch, 'g');
				desc = desc.replace(regExp, '<em>' + param.Name + '</em>');
			}
		}
		return desc;
	}
}